export const isValidString = (value: string | null | undefined): value is string => {
  return typeof value === 'string' && value !== null && value !== undefined && value !== '';
};

export const isValidNumber = (value: number | null | undefined): value is number => {
  return (
    typeof value === 'number' &&
    value !== null &&
    value !== undefined &&
    value !== 0 &&
    !isNaN(value)
  );
};

export const isValidDate = (value: Date | null | undefined): value is Date => {
  if (!value) return false;

  if (!(value instanceof Date)) return false;

  return !isNaN(value.getTime());
};
